import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id B343DEEB-A0ED-41BF-8C86-37D04A1040A6
 * name stop-circle-outline
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/stop-circle-outline.svg
 * tags
 */
export const StopCircleOutlineIcon = createSvgIcon(<><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4M9,9V15H15V9" /></>, 'StopCircleOutlineIcon');
export default StopCircleOutlineIcon